module.exports = __webpack_public_path__ + "static/media/balancedfund.960a5002.jpg";